import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { adaptFacetConfig, adaptFilterConfig, adaptResultFieldsConfig, adaptSearchFieldsConfig } from "./requestAdapters";
export default function adaptRequest(request, queryConfig, documentType) {
  var disjunctiveFacets = queryConfig.disjunctiveFacets,
      disjunctiveFacetsAnalyticsTags = queryConfig.disjunctiveFacetsAnalyticsTags;

  if (disjunctiveFacets) {
    console.warn("search-ui-site-search-connector: disjunctiveFacets is not supported by Site Search");
  }

  if (disjunctiveFacetsAnalyticsTags) {
    console.warn("search-ui-site-search-connector: disjunctiveFacetsAnalyticsTags is not supported by Site Search");
  }

  var updatedFacets = adaptFacetConfig(queryConfig.facets);
  var updatedFilters = adaptFilterConfig(queryConfig.filters !== undefined ? queryConfig.filters : request.filters);
  var page = queryConfig.current !== undefined ? queryConfig.current : request.current;
  var per_page = queryConfig.resultsPerPage !== undefined ? queryConfig.resultsPerPage : request.resultsPerPage;
  var sortDirection = queryConfig.sortDirection !== undefined ? queryConfig.sortDirection : request.sortDirection;
  var sortField = queryConfig.sortField !== undefined ? queryConfig.sortField : request.sortField;

  var _adaptResultFieldsCon = adaptResultFieldsConfig(queryConfig.result_fields),
      _adaptResultFieldsCon2 = _slicedToArray(_adaptResultFieldsCon, 2),
      fetchFields = _adaptResultFieldsCon2[0],
      highlightFields = _adaptResultFieldsCon2[1];

  var updatedSearchFields = adaptSearchFieldsConfig(queryConfig.search_fields);
  var searchTerm = request.searchTerm;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, per_page && {
    per_page: per_page
  }), page && {
    page: page
  }), sortDirection && {
    sort_direction: _defineProperty({}, documentType, sortDirection)
  }), sortField && {
    sort_field: _defineProperty({}, documentType, sortField)
  }), updatedFilters && {
    filters: _defineProperty({}, documentType, updatedFilters)
  }), updatedFacets && {
    facets: _defineProperty({}, documentType, updatedFacets)
  }), fetchFields && {
    fetch_fields: _defineProperty({}, documentType, fetchFields)
  }), highlightFields && {
    highlight_fields: _defineProperty({}, documentType, highlightFields)
  }), updatedSearchFields && !!updatedSearchFields.length && {
    search_fields: _defineProperty({}, documentType, updatedSearchFields)
  }), {}, {
    q: searchTerm
  });
}